/**
 * Thin route elements for the admin screens. The guard is on the ROUTE (App.tsx
 * wraps each of these in RequireAdmin), not in the screens, so a non-admin never
 * mounts a screen and never fires its requests.
 */
import { UserTable } from '../features/admin/UserTable';
import { AccessMatrix } from '../features/admin/AccessMatrix';
import { BlueprintAdmin, ClientDetail, ClientList } from '../features/admin/ClientScreens';
import { ArchiveScreen } from '../features/admin/ArchiveScreen';

export const AdminUsersRoute = UserTable;
export const AdminAccessRoute = AccessMatrix;
export const AdminClientsRoute = ClientList;
export const AdminClientRoute = ClientDetail;
export const AdminBlueprintRoute = BlueprintAdmin;
export const AdminArchiveRoute = ArchiveScreen;
